<template>
 <div style=" padding:20px;margin-top:10px;background: #fff;  " >
  <el-tabs v-model="activeName"  >
  <el-tab-pane label="充值明细" name="first">
  <el-table v-loading="loading"
    :data="tableData1" 
	border 
    style="width: 100%"
    >
 
    <el-table-column 
      prop="create_time"
      label="日期"
      min-width="15%">
    </el-table-column>
    <el-table-column
      prop="sk_name"
      label="服务名称"
      min-width="25%">
    </el-table-column>
    <el-table-column
      prop="sk_amount"
      label="金额"
      min-width="10%">
    </el-table-column>
    <el-table-column
      prop="pay"
      label="支付状态"
      min-width="10%">
    </el-table-column>	
 
 
  </el-table>
  <div style="margin-top:10px; display: flex; align-items:right; justify-content: flex-end;  ">
  <el-pagination @current-change="handlePageChange1" :current-page="page1" :page-size="10" layout="total, prev, pager, next, jumper" :total="total1">
				</el-pagination> </div>
  </el-tab-pane>
  <el-tab-pane label="消费明细" name="second">
  <el-table v-loading="loading"
    :data="tableData2" 
	border 
    style="width: 100%"
    >
 
    <el-table-column
       
      prop="create_time"
      label="日期"
      min-width="15%">
    </el-table-column>
    <el-table-column
      prop="full_name"
      label="领英数据姓名"
      min-width="25%">
    </el-table-column>
    <el-table-column
      prop="job_title"
      label="领英数据职位"
      min-width="25%">
    </el-table-column>	
    <el-table-column
      prop="fee"
      label="金额"
      min-width="10%">
    </el-table-column>
 
 
  </el-table>
  <div style="margin-top:10px; display: flex; align-items:right; justify-content: flex-end;  ">
  <el-pagination @current-change="handlePageChange2" :current-page="page2" :page-size="10" layout="total, prev, pager, next, jumper" :total="total2">
				</el-pagination> </div>
  </el-tab-pane> 
  <el-tab-pane label="余额" name="third">
  <el-input readonly placeholder=" " v-model="amount">
    <template slot="prepend">当前余额：</template>
  </el-input>
  
  </el-tab-pane>  
  </el-tabs>

  </div>
</template>
 
<script>
export default {
    data() {
      return {
	  	page1: 1,
		page2: 1,
		id: 1,
		total1: 0,
		total2: 0,
		size:10,
		amount: 0,
		activeName: 'first',
	    is_loading: false,
		loading: true,
        tableData1: [],
		tableData2: [],
      }
    },
    props: {
        titleSync: String,
      },
	  
    methods: {
		handlePageChange1(val) {
			this.page1 = val;  
			this.getInfo()
		},
		handlePageChange2(val) {
			this.page2 = val;　 
			this.getInfo()
		}, 		
	 　 getInfo(){
 
			let that = this;
			let userInfo = localStorage.getItem('userInfo');
			let info = JSON.parse(userInfo);
			let id = info.id;  
			console.log( userInfo);  
			  $.ajax({
				  type: "GET",
				  data:  {
						 user_id: info.id,
						 page1: that.page1,
						 page2: that.page2, 
						 size: 10,  
						 },
				  url: "https://www.myferp.com/admin/linkedIn/balance",
				  dataType: "json",  //返回类型为 json
				  beforeSend: function (request) {
					request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
					},   
				  error: function(XMLHttpRequest, textStatus, errorThrown) { 
					  that.loading = false;
					  that.$message({
						message: data,
						type: 'error'
						});
							return false;
						},             
				  success: function (data) {
					
					console.log(JSON.stringify(data));
					that.tableData1 = data.data.order_info.data ; 
					that.tableData2 = data.data.bill_info.data ; 
					that.page1 = data.data.order_info.currentPage;
					that.page2 = data.data.bill_info.currentPage;
					that.total1 = data.data.order_info.count;
					that.total2 = data.data.bill_info.count;
					that.amount = data.data.balance;
					that.loading = false;				
					}
				  });	
	  },
 
      onSubmit() { 
			 
			     
      }
    },
    mounted() {
	  this.getInfo();
	},
    computed: {
 
      },	
  }
</script>
 
 


// WEBPACK FOOTER //
// src/components/setting/linkedInDetail.vue